
// const IMAGE_BASE_URL = 'https://localhost:44341/';
const IMAGE_BASE_URL = 'https://services.kojabasham.ir/';
export const getImageUrl = (relativePath: string): string => {
  return `${IMAGE_BASE_URL}${relativePath}`;
};

export default IMAGE_BASE_URL;